import { graphql } from 'gatsby'
import * as React from 'react'
import Header from '../components/header'
import Layout from '../components/layout'
import NextPage from '../components/nextPage'
import OrderedList from '../components/orderedListNews'
import ScrollingTextBanner from '../components/scrollingTextBanner'
import SEO from '../components/seo'
import Spacer from '../components/spacer'

class NewsPage extends React.Component {
	render() {
		const nextPage = this.props.data.news
		const news = nextPage.newsArticles.map(item => ({ node: item }))
		const bannerImage = nextPage.image
		const seo = nextPage.seo
	
		
		return (
			<Layout className='pth'>
				<SEO title={seo?.title || 'News on SIERA Group'} description={seo?.description} image={seo?.image?.url} pathname={this.props.location.pathname} />
				<Header page='News & Articles' />
				<ScrollingTextBanner title='News & Articles' className='h-a' image={bannerImage} textClassName='' />
				<OrderedList target='_blank' secondClassName='text-initial' items={news} />
				<Spacer />
				<NextPage title={nextPage.nexttitle} link={nextPage.nextlink} image={nextPage.nextimage} />
			</Layout>
		)
	}
}

export default NewsPage

export const query = graphql`
	query News {
		news: datoCmsNews {
			image {
				gatsbyImageData
				alt
			}
			nexttitle
			nextlink
			nextimage {
				gatsbyImageData
				alt
			}
			seo {
				description
				title
				image {
					url
				}
			}

			newsArticles {
				... on DatoCmsBlog {
					id
					title: date
					slug
					info
					year
					featureImage: image {
						gatsbyImageData
						alt
					}
				}
				... on DatoCmsArticle {
					id
					info
					title: date
					year
					location: publication
					link
					featureImage: image {
						gatsbyImageData
						alt
					}
				}
			}
		}
	}
`
